import React from "react";

export const RightArrowIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  ...props
}) => (
  <svg
    width="30"
    height="26"
    viewBox="0 0 30 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.68645 15.3526L1.63962 15.3424L21.7143 15.3424L15.4035 21.667C15.0945 21.9758 14.925 22.3941 14.925 22.8331C14.925 23.2722 15.0945 23.6875 15.4035 23.997L16.3855 24.9795C16.6943 25.2883 17.1057 25.459 17.5445 25.459C17.9835 25.459 18.3952 25.2895 18.704 24.9807L29.5218 14.1639C29.8318 13.8539 30.0013 13.4409 30.0001 13.0017C30.0013 12.56 29.8318 12.1468 29.5218 11.8373L18.704 1.01947C18.3952 0.710935 17.9838 0.541179 17.5445 0.541179C17.1057 0.541179 16.6943 0.711179 16.3855 1.01947L15.4035 2.00191C15.0945 2.3102 14.925 2.72191 14.925 3.16094C14.925 3.59971 15.0945 3.98972 15.4035 4.29825L21.7855 10.6583L1.66401 10.6582C0.759868 10.6582 0.000111852 11.4375 0.000111773 12.3412L0.000111652 13.7307C0.000111573 14.6343 0.782308 15.3526 1.68645 15.3526Z"
      fill="currentColor"
    />
  </svg>
);
